<template>
  <div style="width: 220px; margin: 160px 0px 0px 200px">
    <el-table
      :data="newList"
      border
      :style="{height: height}"
      style="width: 100%;overflow-y: auto"
    >
      <el-table-column
        align="center"
        label="测点"
        prop="language">
      </el-table-column>
      <el-table-column
        align="center"
        label="状态/值"
        prop="value">
        <template slot-scope="scope">
          <span class="largeContent">{{ scope.row.value }}{{ scope.row.units }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "ElevatorLayout",
  props: {
    fanData: {
      type: Array,
      default: () => []
    },
    height: {
      type: String,
      default: '241px'
    },
    number: {
      type: Number,
      default: 6,
    }
  },
  data() {
    return {
       operationList: {
        "alarm": 0,
        "deviceId": 213,
        "status": 0,
        "tags": [
          {
            "language": "运行方向",
            "value": "暂停中"
          },
          {
            "language": "所在楼层",
            "value": "1F"
          },
          {
            "language": "运行状态",
            "value": "正常"
          }
        ]
      }
      , newList: []

    }
  }
  ,
  mounted() {
    this.operationListfilter();
  },
  methods: {
    operationListfilter() {
      this.newList = this.operationList.tags.filter(item => {
        if (item.name == 'intp' || item.name == 'ercd' || item.name == 'ftst') {
          return true;
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style scoped>
ul.pointData {
  padding-left: 0;
}

.pointData li {
  width: 238px;
  list-style: none;
  display: inline-block;
  margin: 15px 10px;
}

.pointData .el-table >>> .el-table__header {
  font-size: inherit;
}

.pointData .el-table >>> .el-table__body-wrapper {
  font-size: 0.85rem;
}

.pointData .el-table >>> td, .pointData .el-table >>> th {
  padding: 5px 0;
}

.pointData .el-table--border, .pointData .el-table--group {
  border-left: none;
}

.pointData .el-table >>> .el-table__header-wrapper, .pointData .el-table >>> .el-table__body-wrapper {
  border-left: 1px solid rgba(41, 155, 255, .3);
  border-right: 1px solid rgba(41, 155, 255, .3);
}
</style>
